import { Fab } from '@material-ui/core/';
import styled from 'styled-components';

export const StyledFloatingActionButton = styled(Fab)`
  margin-top: 15px;
  align-self: flex-end;
  color: white;
`;
